<div class="main_content bright">
    <div class="page_main_sec">
        <div class="table_card_sec">
            <div class="row">
                <h1 style="font-size: 15px;">Upload Client Logo</h1>
                <div class="col-lg-5 col-sm-12">
                    <div class="browsefile_main_section" *ngIf="attachmentList.length==0">
                        <input [attr.type]="fileControlType" id="uploadFileName" title="Browse Image"
                            (change)="onSelectFile($event)" />
                        <div class="browse_file_sec">
                            <img src="../../../assets/img/transaction/cloud-upload-alt.png" alt="Browse File" />
                            <span>Drag & Drop Image</span>
                        </div>
                        <div class="browser_or_sec">
                            <span>Or</span>
                        </div>
                        <div class="browse_file_sec">
                            <img src="../../../assets/img/transaction/folder-open-solid.png" alt="Browse File" />
                            <span>Browse Image</span>
                        </div>
                    </div>
                    <div class="files_note_sec">
                        <div *ngIf="this.selectedModule.extension" class="note">Only {{this.selectedModule.extension}}
                            image is allowed.
                        </div>
                        <div *ngIf="attachmentList.length==0" class="files_uploaded_count">
                            Only .png format allowed.<br>
                            Max Allowed Image size is 250KB.
                        </div>
                        <div *ngIf="attachmentList.length>0" class="files_uploaded_count">
                            {{attachmentList.length}} Image is Uploaded. <span class="view_uploaded_doc"
                                (click)="isShowUploadedDocs = true">View File</span>
                        </div>
                        <div class="files_uploaded_count">
                            <span class="view_uploaded_doc" *ngIf="attachmentList.length>0"
                                (click)="isShowPreview = true">Preview Image</span>
                        </div>
                    </div>
                    <div class="uploaded_files_view_sec" *ngIf="isShowUploadedDocs && attachmentList.length>0">
                        <div class="uploaded_files_header">
                            <span>{{attachmentList.length}} Image uploaded successfully.</span>
                            <span (click)="isShowUploadedDocs = false"><i class="material-icons"
                                    title="close">close</i></span>
                        </div>
                        <div class="files_list_sec">
                            <div class="file_status_sec" *ngFor="let file of attachmentList;let i=index">
                                <img src="../../../assets/img/transaction/file_uploaded.png" class="file_uploaded_icon"
                                    alt="File Upload">
                                <div class="file_name_sec">
                                    <div class="file_name_detail">
                                        <span class="status_file_name">{{file.name}}</span>
                                        <img (click)="deleteAttachment(i)"
                                            src="../../../assets/img/transaction/delete.png" alt="delete"
                                            class="files_action_icon file_status_delete">
                                    </div>
                                    <div class="file_status_bar"></div>
                                </div>
                                <span class="file_checked_icon">
                                    <img src="../../../assets/img/transaction/checked.png" alt="Checked">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-5 col-sm-12">

                    <div class="row">
                        <div class="col-lg-12 text-right">
                            <button class="btncss" [class.btn_primary]="attachmentList.length>0"
                                (click)="isShowUploadedDocs = true;uploadFiles()">Upload Files</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div>
            <div>
                <img [src]="logoBase64FileString" class="group_logo" alt="{{uploadFileName}}" *ngIf="isShowPreview">

            </div>
        </div>
        <!-- <div>
            <app-advance-gridview [lstData]="lstFiles" [lstHeaders]="lstHeaders" [gridTitle]="'Uploaded Files'"
                [showColumnGroup]="false" [showAdvanceSearchOption]="false" [showExcelDownloadOption]="true"
                [columnsToHide]="lstColumnsToHide">
            </app-advance-gridview>
        </div> -->
    </div>
</div>